import React, { useEffect, useState, useMemo, useRef } from "react";
import useStyles from "../common/Styles";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import tribeCityMap from "../../../assets/tribal_map.json"; //keeping this parked until cities map is ready
import tribeCityMap from "../../../assets/tribes_CWS_v4_Merge_Merge_Fe.json";
import industryMap from "../../../assets/WH_irrigation_industry_v2_Me5.json";
import irrigationMap from "../../../assets/irrigation_districtsv3.json";
import { Slider, Box, Tooltip, Grid } from "@material-ui/core";
import { usePrevious } from "components/common/usePrevious";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import chip_power_icon from "../../../assets/chip_power_icon.png";
import chip_power_highlight from "../../../assets/chip_power_highlight.png";
import chip_irrigation_icon from "../../../assets/chip_irrigation_icon.png";
import chip_irrigation_highlight from "../../../assets/chip_irrigation_highlight.png";
import chip_mining_icon from "../../../assets/chip_mining_icon.png";
import chip_mining_highlight from "../../../assets/chip_mining_highlight.png";
import map_power_icon from "../../../assets/power_icon.png";
import map_mining_icon from "../../../assets/mining_icon.png";
import userActions from "../actions";
// import appActions from '../../app/actions';

import { sliderValues } from '../utils'
import {
  // alias_entity_id_mapping,
  calculateLegendLabels,
  irrigation_name_mapping,
  // irrigation_use_name_mapping,
  western_arizona_irrigation_districts,
  western_arizona_shapes_included,
} from "./colorado_river_access_constants";
import "rc-tooltip/assets/bootstrap_white.css";
import "./riverAccessMap.css";
import { throttle } from "lodash"

var map;
var allModelLayer1;
var allModelLayer2;
var allModelLayer3;
// var legend;
var legendAllData;
var legendLabel = [];
var irrigationLegendAllData;
var irrigationAccessChangeMax;
// var irrigationAccessChangeMin;
var irrigationLegendLabel = []; 
// Irrigation patterns

var square_shape = new L.PatternRect({
  width: 12,
  height: 12,
  rx: 1,
  ry: 1,
  fill: true
});
var circle_shape = new L.PatternCircle({
  x: 12,
  y: 12,
  radius: 5,
  fill: true
});

var dot_shape = new L.PatternCircle({
  x: 4,
  y: 4,
  radius: 1,
  fill: true
});

// Default Pattern
var default_pattern = new L.StripePattern({
  color: "black",
  angle: 90,
  // spaceColor: "white",
  fill: true,
})

// Square pattern 1
var square_pattern_1 = new L.Pattern({ color: "#7EA6F9", width: 20, height: 20 });
square_pattern_1.addShape(square_shape);


// Square Pattern 2
var square_pattern_2 = new L.Pattern({ color: "#467BE8", width: 20, height: 20, angle: 45 });
square_pattern_2.addShape(square_shape);

// Circle Pattern
var circle_pattern = new L.Pattern({ color: "#225DD8", width: 20, height: 20, angle: 45 });
circle_pattern.addShape(circle_shape);

// Dot Pattern
var dot_pattern = new L.Pattern({ color: "#225DD8", width: 4, height: 4 });
dot_pattern.addShape(dot_shape);

var irrigation_patterns = [
  new L.StripePattern({
    color: "#BDD0F8",
    angle: 15,
    // spaceColor: "white",
    fill: true,
  }),
  square_pattern_1,
  square_pattern_2,
  circle_pattern,
  dot_pattern,
];

const colorsCentralLegend = [
  "#BDD0F8",
  "#7EA6F9",
  "#467BE8",
  "#225DD8",
  "#0C3588",
];

// includedCityColor is the western az hardcoded data

const includedCityColor = {
  fillColor: "#D0D0D0",
  fillOpacity: 0.5,
  weight: 1,
  color: "#707070",
};

const notIncludedCityColor = {
  fillColor: "#C9C9C9",
  fillOpacity: 0.5,
  weight: 1,
  color: "#707070",
};

const valueLabelFormat = (value) => {
  const num = value;

  if (typeof value !== "number") {
    return value;
  }
  // return `Year ${num - 2021}`;
  return num
};

const getColor = (value) => {
  for (var i = 0; i < legendLabel.length; i++) {
    if (value <= legendLabel[i]) {
      return colorsCentralLegend[i];
    }
  }
  return colorsCentralLegend[0];
};

const getIrrigationStyle = (value) => {
  for (var i = 0; i < legendLabel.length; i++) {
    if (value <= legendLabel[i]) {
      return irrigation_patterns[i];
    }
  }
  return default_pattern
}

const ValueLabelComponent = (props) => {
  const classes = useStyles();
  const { children, value } = props;
  const title = valueLabelFormat(value);

  return (
    <Tooltip
      placement="top"
      arrow
      title={title}
      open={true}
      classes={{
        tooltip: classes.technicalTooltipPopper,
      }}
    >
      {children}
    </Tooltip>
  );
};

function ColoradoRiverAccessMap() {
  const classes = useStyles();

  const containerRef = useRef(document.createElement("div"));
  const containerRef1 = useRef(document.createElement("div"));
  const { toggle_about, toggle_about_hidden, city_selected, tribe_selected, is_tribe, slider_range, previousMapSelection, userLastSelectedMapState } = useSelector(
    (state) => state.technical_view
  );
  const [selectedFeature, setSelectedFeature] = useState(null);
  const defaultMapZoom = 5;
  const highlightMapZoom = 8;
  const [mapZoom, setMapZoom] = useState(highlightMapZoom);
  const isInitialMount = useRef(true);
  const previousFeature = usePrevious(selectedFeature);
  const { isMobile } = useGetViewPortDimensions();

  // These values are used in highlightFeature to help with zoom functionality
  // When staying on the same entity, the zoom should not change between slider year changes
  // When select a different entity, mapZoom will go back to default map zoom
  // const selected = useRef(null);
  // const previous = useRef(null);
  const centering = useRef(true);

  const CENTERING_TIMEOUT = 500;
  
  const disableCentering = () => {
    centering.current = false;
    setTimeout(() => {
      centering.current = true;
    }, CENTERING_TIMEOUT); // Centering disable Timeout
  }

  const {
    cities,
    tribes,
    entitlement_year,
    entitlements_by_year,
    access_difference_range,
    // irrigation_district_water_use,
    industry_metrics,
    western_arizona_entities,
    western_arizona_entitlements,
    western_arizona_selected,
    is_western,
    scenario_selected,
    alias_entity_id_mapping,
  } = useSelector((state) => state.technical_view);

  let irrigationEntitlements = [];
  irrigationMap.features.forEach(feature => {
    let displayName = feature.properties["'irrigation districts$'.Display_Name"]
    let irrigation_mapped = irrigation_name_mapping.hasOwnProperty(displayName)
    let mappedName;
    if (irrigation_mapped) {
      mappedName = irrigation_name_mapping[displayName]
    }
    if (alias_entity_id_mapping.hasOwnProperty(displayName)
      || (mappedName && alias_entity_id_mapping.hasOwnProperty(mappedName))) {
      var entity_name;
      if (alias_entity_id_mapping.hasOwnProperty(displayName)) {
        entity_name = displayName;
      } else {
        entity_name = mappedName;
      }
      var entity_id = alias_entity_id_mapping[entity_name];
      let entitlement;
      // let pattern;
      if (entitlements_by_year[entitlement_year])
        entitlement = entitlements_by_year[entitlement_year][entity_id]
      if (western_arizona_entitlements[entitlement_year])
        entitlement = western_arizona_entitlements[entitlement_year][entity_id]
      if (entitlement) {
        irrigationEntitlements.push(entitlement)
      }
    }
  });
  irrigationAccessChangeMax = Math.max(...irrigationEntitlements.map(o => o.percent_access_change_start))
  // irrigationAccessChangeMin = Math.min(...irrigationEntitlements.map(o => o.percent_access_change_start))

  const westernArizonaHasShape = (obj) => {
    return western_arizona_shapes_included.hasOwnProperty(obj.label);
  };

  const cityTribe = cities
    .concat(tribes)
    .concat(western_arizona_entities.filter(westernArizonaHasShape));

  const {
    setSelectedCity,
    loadCityWaterSources,
    setSelectedTribe,
    setPreviousMapSelection,
    loadEntityEntitlements,
    setIsTribe,
    setEntitlementYear,
    loadEntitlementsByYear,
    loadAccessDifferenceRange,
    setSelectedWesternArizonaEntity,
    setIsWesternEntity,
    setIsCity, 
    toggleAboutDrawerHidden,
    setUserLastSelectedMapState
  } = userActions();

  const [powerSelected, setPowerSelected] = useState(false);
  const [irrigationSelected, setIrrigationSelected] = useState(false);
  const [miningSelected, setMiningSelected] = useState(false);

  const handleSliderChange = (e, value) => {
    setEntitlementYear(value);
    // loadAccessDifferenceRange(value);
  };

  const handleSliderChangeCommited = (e, value) => {
    loadEntitlementsByYear(value, scenario_selected.value);
  };

  const loadEntitlements = () => {
    if (slider_range?.length) {
      loadEntitlementsByYear(entitlement_year, scenario_selected.value);
    }
  }
  useEffect(loadEntitlements, [slider_range])

  const loadAccess = () => {
    loadAccessDifferenceRange(scenario_selected.value);
  }
  useEffect(loadAccess, [scenario_selected])

  // useEffect(() => {
  //   setEntitlementYear(2022);
  //   loadEntitlementsByYear(2022);
  //   loadAccessDifferenceRange(2022);
  //   loadWesternArizonaEntitlements();
  //   return () => {
  //     resetSelectedCity();
  //     loadCityMetrics(1);
  //     loadCityWaterSources(1);
  //     setIsTribe(false);
  //     setIsWesternEntity(false);
  //   };
  // }, []);

  const handleChange = (value) => {
    // if (value <= 41) {
    //   setSelectedCity(cities.find((city) => city.value === value));
    //   loadCityMetrics(value);
    //   loadCityWaterSources(value);
    //   setIsTribe(false);
    //   setIsWesternEntity(false);
    //   loadEntityEntitlements(value, scenario_selected.value);
    // } else if (value <= 50) {
    //   setSelectedTribe(tribes.find((tribe) => tribe.value === value));
    //   loadTribeMetrics(value);
    //   setIsTribe(true);
    //   setIsWesternEntity(false);
    //   loadEntityEntitlements(value, scenario_selected.value);
    // } else {
    //   setSelectedWesternArizonaEntity(
    //     western_arizona_entities.find((entity) => entity.value === value)
    //   );
    //   setIsWesternEntity(true);
    //   setIsTribe(false);
    // }
    var entityFound = cityTribe.find((entity) => entity.value === value);
    if (entityFound.entity_type === "Central") {
      setSelectedCity(entityFound);
      loadCityWaterSources(value);
      setIsCity(true)
      setIsTribe(false);
      setIsWesternEntity(false);
      loadEntityEntitlements(value, scenario_selected.value);
    }
    else if (entityFound.entity_type === "Tribe") {
      setSelectedTribe(entityFound);
      // loadTribeMetrics(value);
      setIsTribe(true);
      setIsCity(false)
      setIsWesternEntity(false);
      loadEntityEntitlements(value, scenario_selected.value);
    }
    else {
      setSelectedWesternArizonaEntity(entityFound);
      setIsCity(false)
      setIsWesternEntity(true);
      setIsTribe(false);
    }
  };

  const handlePowerClicked = () => {
    // first disable irrigation mode to do anything 
    if (irrigationSelected) {
      return
    }

    // 👇️ toggle
    setPowerSelected((current) => !current);
    // in power mode the irrigation widget is disabled
    setIrrigationSelected(false);
  };

  const handleIrrigationClicked = () => {
    //toggleAboutDrawerHidden();
    // Leaflet documentation
    map._onResize()
    // 👇️ toggle
    setIrrigationSelected((current) => {
      // in irrigation mode the other two widgets are disabled
      if (!current) {
        setMiningSelected((current) => false);
        setPowerSelected((current) => false);
      }
      return !current
    }
    );

  };

  const handleMiningClicked = () => {
    // first disable irrigation mode to do anything 
    if (irrigationSelected) {
      return
    }

    // 👇️ toggle
    setMiningSelected((current) => !current);
    // in mining mode the irrigation widget is disabled
    setIrrigationSelected(false);
  };


  // renders filter components
  const displayTopSection = () => {
    return (
      <Grid
        container
        className={classes.mapFilterGrid}
        alignItems="center"
        // justify="center"
      >
        {/* 
          Note: Commenting this dropdown since the title in charts sidebar is replaced with this dropbox.
          Check https://asudev.jira.com/browse/CURVE-369 for more info
          {!isMobile && (
          <ColoradoRiverAccessLocationFilter
            location_options={cityTribe}
            handleChange={handleChange}
            city_id={city_selected.city_id}
            style={{ marginRight: 14 }}
          />
        )} */}
        <Grid
          style={{ marginRight: "14px" }}
          item
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            className={classes.mapFilterChips}
            style={{
              backgroundColor: irrigationSelected ? "#dfe0d8" : (powerSelected ? "#EBF0FD" : "#FFFFFF"),
            }}
            onClick={handlePowerClicked}
          >
            <img
              className={classes.mapFilterChipIcon}
              style={{ height: "18px", marginRight: "10px" }}
              src={powerSelected ? chip_power_highlight : chip_power_icon}
              alt="chip-icon.png"
            />
            <p
              className={classes.mapFilterChipLabel}
              style={{
                color: powerSelected ? "#2352D0" : "#757575",
              }}
            >
              Power
            </p>
          </Box>
        </Grid>
        <Grid item>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            className={classes.mapFilterChips}
            style={{
              backgroundColor: irrigationSelected ? "#dfe0d8" : (miningSelected ? "#EBF0FD" : "#FFFFFF"),
            }}
            onClick={handleMiningClicked}
          >
            <img
              className={classes.mapFilterChipIcon}
              style={{ height: "18px", marginRight: "10px" }}
              src={miningSelected ? chip_mining_highlight : chip_mining_icon}
              alt="chip-icon.png"
            />
            <p
              className={classes.mapFilterChipLabel}
              style={{
                color: miningSelected ? "#2352D0" : "#757575",
              }}
            >
              Mining
            </p>
          </Box>
        </Grid>
        {/* <Grid
          style={{ marginRight: "14px" }}
          item
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            className={classes.mapFilterChips}
            style={{
              backgroundColor: irrigationSelected ? "#EBF0FD" : "#FFFFFF",
            }}
            onClick={handleIrrigationClicked}
          >
            <img
              className={classes.mapFilterChipIcon}
              style={{ height: "18px", marginRight: "10px" }}
              src={
                irrigationSelected
                  ? chip_irrigation_highlight
                  : chip_irrigation_icon
              }
              alt="chip-icon.png"
            />
            <p
              className={classes.mapFilterChipLabel}
              style={{
                color: irrigationSelected ? "#2352D0" : "#757575",
              }}
            >
              Irrigation Districts
            </p>
          </Box>
        </Grid> */}
      </Grid>
    )
  }
  const widget = useMemo(displayTopSection,
    [cities, powerSelected, irrigationSelected, miningSelected, city_selected]
  );

  const SliderComponent = () => {
    return (
      <div className={classes.mapSlider}>
        <Box className={classes.mapSliderContainer}>
          {/* <Typography variant="caption" className={classes.sliderLabel}>
                    100%
                    </Typography> */}
          <Slider
            min={sliderValues.min_value}
            max={sliderValues.max_value}
            marks={sliderValues.range}
            step={1}
            orientation="horizontal"
            classes={{
              root: classes.slider,
              rail: classes.sliderRail,
              valueLabel: classes.sliderValueLabel,
              thumb: classes.sliderThumb,
              // horizontal: classes.sliderVertical,
              mark: classes.sliderMark,
              track: classes.sliderTrack,
            }}
            value={entitlement_year}
            valueLabelDisplay="on"
            getAriaValueText={valueLabelFormat}
            valueLabelFormat={valueLabelFormat}
            ValueLabelComponent={ValueLabelComponent}
            onChange={handleSliderChange}
            onChangeCommitted={throttle(handleSliderChangeCommited, 200)}
          />
        </Box>
      </div>
    )
  }
  const widget1 = useMemo(SliderComponent,
    [slider_range, entitlement_year]
  );

  var mouseX = 0,
    mouseY = 0;
  var startTimerID;

  // useEffect(() => {
  //   setMapZoom(mapZoom);
  // }, [city_selected, tribe_selected]);

  const onEachFeature = (feature, layer) => {
    if (alias_entity_id_mapping.hasOwnProperty(feature.properties.name_1)) {
      var entity_id = alias_entity_id_mapping[feature.properties.name_1];
      layer
        .setStyle(includedCityColor)
        .bindPopup(cityPopup(feature.properties.name_1), {
          closeOnClick: false,
          autoPan: false,
        })
        .on("mouseover", function (e) {
          // this.openPopup(e.latlng);
          startTimerID = setTimeout(() => {
            layer.openPopup(L.latLng(mouseX, mouseY));
          }, 500);
        })
        .on("mouseout", function (e) {
          // this.closePopup();
          clearTimeout(startTimerID);
        })
        .on("mousemove", function (e) {
          mouseX = e.latlng.lat;
          mouseY = e.latlng.lng;
        })
        .on("click", function (e) {
          map.closePopup();
          handleChange(entity_id);
         highlightFeature(layer, true);
        });
      var access_change_percent = 0;
      if (entitlements_by_year[entity_id]) {
        access_change_percent =
          entitlements_by_year[entity_id]["percent_access_change_start"];
        layer.setStyle({
          fillColor:
            entitlement_year === 2024 || access_change_percent === 0
              ? "#D0D0D0"
              : getColor(access_change_percent),
        });
      } else if (
        entity_id >= 51 &&
        western_arizona_entitlements[entitlement_year] &&
        western_arizona_entitlements[entitlement_year][entity_id]
      ) {
        access_change_percent =
          western_arizona_entitlements[entitlement_year][entity_id][
          "percent_access_change_start"
          ];
        layer.setStyle({
          fillColor:
            entitlement_year === 2022 || access_change_percent === 0
              ? "#D0D0D0"
              : getColor(access_change_percent),
        });
      }

      if (!is_tribe && !is_western) {
        if (entity_id === city_selected.city_id) {
          setSelectedFeature(layer);
          if (previousMapSelection !== entity_id) {
            setPreviousMapSelection(entity_id)
            highlightFeature(layer, true);
          } else {
            highlightFeature(layer, false);
          }
        }
      } else if (!is_western && is_tribe) {
        if (entity_id === tribe_selected.tribe_id) {
          setSelectedFeature(layer);
          if (previousMapSelection !== entity_id) {
            setPreviousMapSelection(entity_id)
            highlightFeature(layer, true);
          } else {
            highlightFeature(layer, false);
          }
        }
      } else {
        if (entity_id === western_arizona_selected.entity_id) {
          setSelectedFeature(layer);
          if (previousMapSelection !== entity_id) {
            setPreviousMapSelection(entity_id)
            highlightFeature(layer, true);
          } else {
            highlightFeature(layer, false);
          }
        }
      }
    } else {
      layer
        .setStyle(notIncludedCityColor)
        .bindTooltip(feature.properties.name_1, { direction: "top" });
    }
  };

  const centerFeature = (layer) => {
    if (centering.current) {
      const newCenter = new L.LatLngBounds(
        new L.LatLng(
          layer._bounds._northEast.lat,
          layer._bounds._northEast.lng
        ),
        new L.LatLng(
          layer._bounds._southWest.lat,
          layer._bounds._northEast.lng
        )
      ).getCenter();
      if (isInitialMount.current) {
        map.setView(
          newCenter,
          defaultMapZoom
        );
      } else {
        map.setView(
          newCenter,
          mapZoom
        );
      }
      disableCentering();
    }
  }

  const highlightFeature = (layer, center) => {
    // let layer = e.target;
    layer.setStyle({
      weight: 3,
      color: "#000",
    });

    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
      layer.bringToFront();
    }
    // We use the alt_name to see if the previous city selected matches the current city selected.
    // Some entities like Phoenix have two different features with different ids, the only thing that is the same is the alt_name
    if (center) {
      centerFeature(layer);
    } else if (!isInitialMount) {
      map.setZoom(mapZoom)
    }
  };

  const handleDrawer = () => {
    // Show about drawer on map load
    if (toggle_about_hidden){
      toggleAboutDrawerHidden();
    }
    if (map) {
      map.remove();
    }  
    map = L.map("map", {
      center:
        selectedFeature === null
          ? new L.LatLngBounds(
            new L.LatLng(31.9, -113),
            new L.LatLng(35.2, -111.2)
          ).getCenter()
          : new L.LatLngBounds(
            new L.LatLng(
              selectedFeature._bounds._northEast.lat,
              selectedFeature._bounds._northEast.lng
            ),
            new L.LatLng(
              selectedFeature._bounds._southWest.lat,
              selectedFeature._bounds._northEast.lng
            )
          ).getCenter(),
      zoomControl: false,
      doubleClickZoom: true,
      scrollWheelZoom: true,
      attributionControl: false,
      zoom: defaultMapZoom,
      maxZoom: 17,
      // maxZoom: 11,
      minZoom: 7,
      maxBounds: [
        //south-west coordinates
        // [32, -113],
        [30, -115],
        //north-east coordinates
        // [35, -111.0]
        [39, -108.0],
      ],
      maxBoundsViscosity: 1.0,
      layers: [
        L.tileLayer(
          "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png",
          {
            noWrap: true,
            attribution:
              '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: "abcd",
          }
        ),
      ],
    });
    // updates mapZoom whenever zoom in - when we're zoomed into a city and change slider year, the mapZoom will remain the same -> we use mapZoom in highlightFeature
    map.on("zoomend", () => {
      setMapZoom(map.getZoom());
    });
    // add zoom control
    if (!isMobile) {
      L.control
        .zoom({
          position: "topright",
        })
        .addTo(map);
    }
  }
  useEffect(handleDrawer, [toggle_about, isMobile]);

  const toggleFunc = () => {
    return () => {
      if (toggle_about_hidden) 
        toggleAboutDrawerHidden();
    }
  }
  useEffect(toggleFunc, [toggle_about_hidden])

  // using isInitialMount to know if the map should be all the way zoomed out (or zoomed into selected feature)
  // change isInitialMount.current to false when the dropdown filter is used to select a different entity
  const setRefHook = () => {
    if (isInitialMount.current) {
    if (city_selected.name !== "Phoenix" || is_tribe || is_western) {
    isInitialMount.current = false;
    }
    }
    }
    useEffect(setRefHook, [city_selected, is_tribe, is_western]);

  // const findDuplicates = (arr) => {
  //   let seen = {};
  //   let duplicates = arr.filter((item) => {
  //     if (seen[item]) {
  //       return true;
  //     }
  //     seen[item] = true;
  //     return false;
  //   });
  //   return duplicates;
  // }

  const updateMap = () => {
    for (let pattern of irrigation_patterns) {
      pattern.addTo(map)
    }
    default_pattern.addTo(map)
    if (allModelLayer1) {
      allModelLayer1.remove();
    }
    if (allModelLayer2) {
      allModelLayer2.remove();
    }
    if (allModelLayer3) {
      allModelLayer3.remove();
    }
    allModelLayer1 = L.geoJSON(tribeCityMap, {
      // pointToLayer,
      onEachFeature,
    }).addTo(map);
    allModelLayer2 = L.geoJSON(industryMap, {
      pointToLayer,
    }).addTo(map);
    if (irrigationSelected) {
      allModelLayer3 = L.geoJSON(irrigationMap, {
        onEachFeature: irrigationOnEachFeature,
      }).addTo(map);
    }
  }

  useEffect(updateMap, [
    toggle_about,
    city_selected,
    tribe_selected,
    is_tribe,
    is_western,
    western_arizona_selected,
    powerSelected,
    miningSelected,
    irrigationSelected,
    entitlements_by_year,
  ]);

  const setPreviousFeatureStyle = () => {
    if (previousFeature) {
      previousFeature.setStyle({
        fillColor: "#699EE0",
        fillOpacity: 0.5,
        weight: 1,
        color: "#707070",
      });
    }
  }
  useEffect(setPreviousFeatureStyle, [selectedFeature, city_selected, tribe_selected]);

  const mapFunctionality = () => {
    if (map) {
      const Control = L.Control.extend({
        onAdd() {
          L.DomEvent.disableScrollPropagation(containerRef.current);
          containerRef.current.onmouseenter = (e) => map.dragging.disable();
          containerRef.current.onmouseleave = (e) => map.dragging.enable();
          return containerRef.current;
        },
      });
      const control = new Control({
        position: "topleft",
      });
      map.addControl(control);
      return () => {
        map.removeControl(control);
      };
    }
  }
  useEffect(mapFunctionality, [map, toggle_about]);

  const setMapFunc = () => {
    if (map) {
      const Control = L.Control.extend({
        onAdd() {
          L.DomEvent.disableScrollPropagation(containerRef1.current);
          containerRef1.current.onmouseenter = (e) => map.dragging.disable();
          containerRef1.current.onmouseleave = (e) => map.dragging.enable();
          return containerRef1.current;
        },
      });
      const control = new Control({
        position: "bottomleft",
      });
      map.addControl(control);
      return () => {
        map.removeControl(control);
      };
    }
  }
  useEffect(setMapFunc, [map, toggle_about]);

  var IndustryIcon = L.Icon.extend({
    options: {
      iconSize: [18, 18],
      iconAnchor: [9, 9],
      popupAnchor: [0, -9],
    },
  });

  function powerMiningPopup(name) {
    var industryData = industry_metrics[name];
    var html = "<p><b>" + name + "</b></p>";
    if (industryData) {
      html +=
        "<p>Total Colorado River water 2020: <strong>" +
        Math.round(industryData.total_colorado_water_use).toLocaleString(
          "en-US"
        ) +
        " ac-ft</strong></p>";
    } else {
      html +=
        "<p>Total Colorado River water 2020: <strong>xxx,xxx ac-ft</strong></p>";
    }
    return html;
  }

  // function irrigationPopup(name) {
  //   name = irrigation_name_mapping[name];
  //   var useData = irrigation_district_water_use[name];
  //   var html = "<p><b>" + name + "</b></p>";

  //   // Note: Commenting below code since we only need to add entity name on hover
  //   // Check https://asudev.jira.com/browse/CURVE-369 for details
  //   // if (useData) {
  //   //   var topSource = "Colorado River";
  //   //   var max = 0;
  //   //   var sum = 0;
  //   //   for (const [source, value] of Object.entries(useData)) {
  //   //     sum += value;
  //   //     if (value > max) {
  //   //       topSource = irrigation_use_name_mapping[source];
  //   //       max = value;
  //   //     }
  //   //   }
  //   //   html +=
  //   //     "<p>Total Colorado River water 2020: <strong>" +
  //   //     Math.round(sum).toLocaleString("en-US") +
  //   //     " ac-ft</strong></p>";
  //   //   html += "<p>Top Source of Water: <strong>" + topSource + "</strong></p>";
  //   // } else {
  //   //   html +=
  //   //     "<p>Total Colorado River water 2020: <strong>xxx,xxx ac-ft</strong></p>";
  //   //   html += "<p>Top Source of Water: <strong>Colorado River</strong></p>";
  //   // }

  //   return html;
  // }

  // function westernArizonaPopup(name) {
  //   var entity_id = alias_entity_id_mapping[name];
  //   var actual_name = western_arizona_entities[entity_id - 51] // Western Arizona entities start from ID 51
  //     ? western_arizona_entities[entity_id - 51]["label"]
  //     : name;
  //   var html = "<p><b>" + actual_name + "</b></p>";

  //   // Note: Commenting below code since we only need to add entity name on hover
  //   // Check https://asudev.jira.com/browse/CURVE-369 for details
  //   // html += "<p>Year: <strong>" + entitlement_year + "</strong></p>";
  //   // html +=
  //   //   "<p>Colorado River access: <strong>" +
  //   //   (western_arizona_entitlements[entitlement_year] &&
  //   //   western_arizona_entitlements[entitlement_year][entity_id]
  //   //     ? Math.round(
  //   //         western_arizona_entitlements[entitlement_year][entity_id]["p13"] +
  //   //           western_arizona_entitlements[entitlement_year][entity_id]["p4"]
  //   //       ).toLocaleString("en-US")
  //   //     : 0) +
  //   //   " ac-ft</strong></p>";
  //   // html +=
  //   //   "<p>P1-3: <strong>" +
  //   //   (western_arizona_entitlements[entitlement_year] &&
  //   //   western_arizona_entitlements[entitlement_year][entity_id]
  //   //     ? Math.round(
  //   //         western_arizona_entitlements[entitlement_year][entity_id]["p13"]
  //   //       ).toLocaleString("en-US")
  //   //     : 0) +
  //   //   " ac-ft</strong></p>";
  //   // html +=
  //   //   "<p>P4: <strong>" +
  //   //   (western_arizona_entitlements[entitlement_year] &&
  //   //   western_arizona_entitlements[entitlement_year][entity_id]
  //   //     ? Math.round(
  //   //         western_arizona_entitlements[entitlement_year][entity_id]["p4"]
  //   //       ).toLocaleString("en-US")
  //   //     : 0) +
  //   //   " ac-ft</strong></p>";
  //   return html;
  // }

  function cityPopup(name) {
    // var html;
    if (alias_entity_id_mapping.hasOwnProperty(name)) {
      var entity_id = alias_entity_id_mapping[name];
      var actual_name_obj = cityTribe.find((city) => city.value === entity_id);

      var html =
        "<p><b>" +
        (actual_name_obj !== undefined ? actual_name_obj.label : name) +
        "</b></p>";

      // Note: Commenting below code since we only need to add entity name on hover
      // Check https://asudev.jira.com/browse/CURVE-369 for details
      // html += "<p>Year: <strong>" + entitlement_year + "</strong></p>";
      // html +=
      //   "<p>Colorado River access: <strong>" +
      //   (entitlements_by_year[entity_id]
      //     ? Math.round(
      //         entitlements_by_year[entity_id].total_co_access
      //       ).toLocaleString("en-US")
      //     : 0) +
      //   " ac-ft</strong></p>";
      // html +=
      //   "<p>P3: <strong>" +
      //   (entitlements_by_year[entity_id]
      //     ? Math.round(entitlements_by_year[entity_id].p3).toLocaleString(
      //         "en-US"
      //       )
      //     : 0) +
      //   " ac-ft</strong></p>";
      // html +=
      //   "<p>Indian: <strong>" +
      //   (entitlements_by_year[entity_id]
      //     ? Math.round(entitlements_by_year[entity_id].indian).toLocaleString(
      //         "en-US"
      //       )
      //     : 0) +
      //   " ac-ft</strong></p>";
      // html +=
      //   "<p>M&I: <strong>" +
      //   (entitlements_by_year[entity_id]
      //     ? Math.round(entitlements_by_year[entity_id].mi).toLocaleString(
      //         "en-US"
      //       )
      //     : 0) +
      //   " ac-ft</strong></p>";
      // html +=
      //   "<p>NIA A: <strong>" +
      //   (entitlements_by_year[entity_id]
      //     ? Math.round(entitlements_by_year[entity_id].nia_a).toLocaleString(
      //         "en-US"
      //       )
      //     : 0) +
      //   " ac-ft</strong></p>";
      // html +=
      //   "<p>NIA B: <strong>" +
      //   (entitlements_by_year[entity_id]
      //     ? Math.round(entitlements_by_year[entity_id].nia_b).toLocaleString(
      //         "en-US"
      //       )
      //     : 0) +
      //   " ac-ft</strong></p>";
      // html +=
      //   "<p>DCP NIA: <strong>" +
      //   (entitlements_by_year[entity_id]
      //     ? Math.round(entitlements_by_year[entity_id].dcp_nia).toLocaleString(
      //         "en-US"
      //       )
      //     : 0) +
      //   " ac-ft</strong></p>";
      // html +=
      //   "<p>Leases & Exchanges: <strong>" +
      //   (entitlements_by_year[entity_id]
      //     ? Math.round(
      //         entitlements_by_year[entity_id].leases_exchanges
      //       ).toLocaleString("en-US")
      //     : 0) +
      //   " ac-ft</strong></p>";
      return html;
    } else {
      let html = "<p><b>" + name + "</b></p>";
      html += "<p>Year: <strong>" + entitlement_year + "</strong></p>";
      html += "<p>Colorado River access: <strong>xxx,xxx ac-ft</strong></p>";
      html += "<p>NIA: <strong>xxx,xxx ac-ft</strong></p>";
      html += "<p>Priority P3: <strong>xxx,xxx ac-ft</strong></p>";
      html += "<p>Priority P4: <strong>xxx,xxx ac-ft</strong></p>";
      return html;
    }

    // return html;
  }

  // function tribePopup(name) {
  //   // var html;
  //   if (alias_entity_id_mapping.hasOwnProperty(name)) {
  //     var entity_id = alias_entity_id_mapping[name];
  //     var actual_name = cityTribe[entity_id - 1]
  //       ? cityTribe[entity_id - 1]["label"]
  //       : name;
  //     var html = "<p><b>" + actual_name + "</b></p>";

  //     // Note: Commenting below code since we only need to add entity name on hover
  //     // Check https://asudev.jira.com/browse/CURVE-369 for details
  //     // html += "<p>Year: <strong>" + entitlement_year + "</strong></p>";
  //     // html +=
  //     //   "<p>Colorado River access: <strong>" +
  //     //   (entitlements_by_year[entity_id]
  //     //     ? Math.round(
  //     //         entitlements_by_year[entity_id].total_co_access
  //     //       ).toLocaleString("en-US")
  //     //     : 0) +
  //     //   " ac-ft</strong></p>";
  //     // html +=
  //     //   "<p>P3: <strong>" +
  //     //   (entitlements_by_year[entity_id]
  //     //     ? Math.round(entitlements_by_year[entity_id].p3).toLocaleString(
  //     //         "en-US"
  //     //       )
  //     //     : 0) +
  //     //   " ac-ft</strong></p>";
  //     // html +=
  //     //   "<p>Indian: <strong>" +
  //     //   (entitlements_by_year[entity_id]
  //     //     ? Math.round(entitlements_by_year[entity_id].indian).toLocaleString(
  //     //         "en-US"
  //     //       )
  //     //     : 0) +
  //     //   " ac-ft</strong></p>";
  //     // html +=
  //     //   "<p>M&I: <strong>" +
  //     //   (entitlements_by_year[entity_id]
  //     //     ? Math.round(entitlements_by_year[entity_id].mi).toLocaleString(
  //     //         "en-US"
  //     //       )
  //     //     : 0) +
  //     //   " ac-ft</strong></p>";
  //     // html +=
  //     //   "<p>NIA: <strong>" +
  //     //   (entitlements_by_year[entity_id]
  //     //     ? Math.round(
  //     //         entitlements_by_year[entity_id].nia_a +
  //     //           entitlements_by_year[entity_id].nia_b
  //     //       ).toLocaleString("en-US")
  //     //     : 0) +
  //     //   " ac-ft</strong></p>";
  //     // html +=
  //     //   "<p>Federally Firmed Water: <strong>" +
  //     //   (entitlements_by_year[entity_id]
  //     //     ? Math.round(
  //     //         entitlements_by_year[entity_id].leases_exchanges
  //     //       ).toLocaleString("en-US")
  //     //     : 0) +
  //     //   " ac-ft</strong></p>";
  //     // html +=
  //     //   "<p>DCP NIA: <strong>" +
  //     //   (entitlements_by_year[entity_id]
  //     //     ? Math.round(entitlements_by_year[entity_id].dcp_nia).toLocaleString(
  //     //         "en-US"
  //     //       )
  //     //     : 0) +
  //     //   " ac-ft</strong></p>";
  //     // html +=
  //     //   "<p>Leases & Exchanges: <strong>" +
  //     //   (entitlements_by_year[entity_id]
  //     //     ? Math.round(
  //     //         entitlements_by_year[entity_id].obligation
  //     //       ).toLocaleString("en-US")
  //     //     : 0) +
  //     //   " ac-ft</strong></p>";
  //     return html;
  //   } else {
  //     var html = "<p><b>" + name + "</b></p>";
  //     html += "<p>Year: <strong>" + entitlement_year + "</strong></p>";
  //     html += "<p>Colorado River access: <strong>xxx,xxx ac-ft</strong></p>";
  //     html += "<p>NIA: <strong>xxx,xxx ac-ft</strong></p>";
  //     html += "<p>Priority P3: <strong>xxx,xxx ac-ft</strong></p>";
  //     html += "<p>Priority P4: <strong>xxx,xxx ac-ft</strong></p>";
  //     return html;
  //   }

  //   // return html;
  // }

  const pointToLayer = (feature, latlng) => {
    if (feature.properties.entity_typ === "Irrigation district" || western_arizona_irrigation_districts.hasOwnProperty(feature.properties.name_1)) {
      return
    }
    if (
      (feature.properties.industry_t === "power" && !powerSelected) ||
      (feature.properties.industry_t === "mining" && !miningSelected))
      return;
    var icon = new IndustryIcon({
      iconUrl:
        feature.properties.industry_t === "power"
          ? map_power_icon
          : map_mining_icon,
    });
    var name = "";
    // feature.properties.industry_t === " "
    //   ? feature.properties.name
    //   : feature.properties.name_map;

    const marker = L.marker(latlng, { icon: icon });
    if (
      feature.properties.industry_t === "power" ||
      feature.properties.industry_t === "mining"
    ) {
      name = feature.properties.name_map;
      marker.bindPopup(powerMiningPopup(name));
    }

    marker.on("mouseover", function (e) {
      // this.openPopup(e.latlng);
      startTimerID = setTimeout(() => {
        marker.openPopup(L.latLng(mouseX, mouseY));
      }, 500);
    });
    marker.on("mouseout", function (e) {
      // this.closePopup();
      clearTimeout(startTimerID);
    });
    marker.on("mousemove", function (e) {
      mouseX = e.latlng.lat;
      mouseY = e.latlng.lng;
    });

    if (
      feature.properties.industry_t === "power" ||
      feature.properties.industry_t === "mining"
    ) {
      return marker;
    };
  };


  const irrigationOnEachFeature = (feature, layer) => {
    let displayName = feature.properties["'irrigation districts$'.Display_Name"]
    let irrigation_mapped = irrigation_name_mapping.hasOwnProperty(displayName)
    let mappedName;
    if (irrigation_mapped) {
      mappedName = irrigation_name_mapping[displayName]
    }
    if (alias_entity_id_mapping.hasOwnProperty(displayName)
      || (mappedName && alias_entity_id_mapping.hasOwnProperty(mappedName))) {
      var entity_name;
      if (alias_entity_id_mapping.hasOwnProperty(displayName)) {
        entity_name = displayName;
      } else {
        entity_name = mappedName;
      }
      var entity_id = alias_entity_id_mapping[entity_name];
      let entitlement;
      let pattern;
      if (entitlements_by_year[entitlement_year])
        entitlement = entitlements_by_year[entitlement_year][entity_id]
      if (western_arizona_entitlements[entitlement_year])
        entitlement = western_arizona_entitlements[entitlement_year][entity_id]
      if (!entitlement)
        pattern = default_pattern
      else {
        pattern = getIrrigationStyle(entitlement["percent_access_change_start"])
      }
      layer
        .setStyle({
          fillPattern: pattern,
          weight: 1,
          color: "grey"
        })
        .bindPopup(cityPopup(entity_name), {
          closeOnClick: false,
          autoPan: false,
        })
        .on("mouseover", function (e) {
          // this.openPopup(e.latlng);
          startTimerID = setTimeout(() => {
            layer.openPopup(L.latLng(mouseX, mouseY));
          }, 500);
        })
        .on("mouseout", function (e) {
          // this.closePopup();
          clearTimeout(startTimerID);
        })
        .on("mousemove", function (e) {
          mouseX = e.latlng.lat;
          mouseY = e.latlng.lng;
        })
        .on("click", function (e) {
          map.closePopup();
          // handleChange(entity_id);
          // highlightFeature(layer);
          centerFeature(layer);
        });


      layer
        .setStyle({
          // fillPattern: irrigation_pattern,
          ...notIncludedCityColor
        }
        )
        .bindTooltip(feature.properties["'irrigation districts$'.Display_Name"], { direction: "top" });
    }
  };

  useEffect(() => {
    if (legendAllData) {
      legendAllData.remove();
    }
    legendAllData = L.control({
      position: "bottomright",
    });
    legendLabel = calculateLegendLabels(
      access_difference_range.max_percent_change,
      access_difference_range.min_percent_change
    );
    legendAllData.onAdd = function (map) {
      var div = L.DomUtil.create("div", "info legend");
      div.setAttribute("style", "margin-right: 40px");
      div.innerHTML += `<div style="padding: 0px 0px 15px" class='legendTitle'> % Change <br> </div>`;
      div.innerHTML += `<div class ='legendContent'><i style="background:${colorsCentralLegend[0]
        }"></i>Less than or equal to ${legendLabel[0] > 0 ? "+" : ""
        } ${Math.round(legendLabel[0])}%</div><br/>`;
      div.innerHTML += `<div class ='legendContent'><i style="background:${colorsCentralLegend[1]
        }"></i>${legendLabel[0] > 0 ? "+" : ""} ${Math.round(
          legendLabel[0] + 1
        )}% to ${legendLabel[1] > 0 ? "+" : ""}${Math.round(
          legendLabel[1]
        )}%</div><br/>`;
      div.innerHTML += `<div class ='legendContent'><i style="background:${colorsCentralLegend[2]
        }"></i>${legendLabel[1] > 0 ? "+" : ""}${Math.round(
          legendLabel[1] + 1
        )}% to ${legendLabel[2] > 0 ? "+" : ""}${Math.round(
          legendLabel[2]
        )}%</div><br/>`;
      div.innerHTML += `<div class ='legendContent'><i style="background:${colorsCentralLegend[3]
        }"></i>${legendLabel[2] > 0 ? "+" : ""}${Math.round(
          legendLabel[2] + 1
        )}% to ${legendLabel[3] > 0 ? "+" : ""}${Math.round(
          legendLabel[3]
        )}%</div><br/>`;
      div.innerHTML += `<div class ='legendContent'><i style="background:${colorsCentralLegend[4]
        }"></i>${legendLabel[3] > 0 ? "+" : ""}${Math.round(
          legendLabel[3] + 1
        )}% to ${legendLabel[4] > 0 ? "+" : ""}${Math.round(
          legendLabel[4]
        )}%</div><br/>`;
      div.innerHTML += `<div class ='legendContent'><i style="background:${"#D0D0D0"}"></i>${legendLabel[4] > 0 ? "No Change" : ""
        }</div><br/>`;

      return div;
    };
    legendAllData.addTo(map);
  }, [toggle_about, access_difference_range]);

  // useEffect(() => {
  //   if (irrigationLegendAllData) {
  //     irrigationLegendAllData.remove();
  //   }
  //   irrigationLegendAllData = L.control({
  //     position: "bottomright",
  //   });
  //   if (irrigationAccessChangeMax !== 0) {
  //     irrigationLegendLabel = calculateLegendLabels(
  //       access_difference_range.irrigationAccessChangeMax,
  //       access_difference_range.irrigationAccessChangeMin
  //     );
    
  //   irrigationLegendAllData.onAdd = function (map) {
  //     var div = L.DomUtil.create("div", "info irrigation-legend legend");
  //     div.setAttribute("style", "margin-right: 40px");
  //     div.innerHTML += `<div style="padding: 0px 0px 15px" class='legendTitle'> % Change <br>(Maximum)</br> </div>`;
  //     div.innerHTML += `<div class ='legendContent'><i style="background-image:url(/images/slant_blue_stripe.png); background-size:contain;"></i>Less than or equal to ${irrigationLegendLabel[0] > 0 ? "+" : ""
  //       } ${Math.round(irrigationLegendLabel[0])}%</div><br/>`;
  //     div.innerHTML += `<div class ='legendContent'><i style="background-image:${"url(/images/blue_square.png); background-size:contain;"
  //       }"></i>${irrigationLegendLabel[0] > 0 ? "+" : ""} ${Math.round(
  //         irrigationLegendLabel[0] + 1
  //       )}% to ${irrigationLegendLabel[1] > 0 ? "+" : ""}${Math.round(
  //         irrigationLegendLabel[1]
  //       )}%</div><br/>`;
  //     div.innerHTML += `<div class ='legendContent'><i style="background-image:${"url(/images/blue_diamond.png); background-size:contain;"
  //       }"></i>${irrigationLegendLabel[1] > 0 ? "+" : ""}${Math.round(
  //         irrigationLegendLabel[1] + 1
  //       )}% to ${irrigationLegendLabel[2] > 0 ? "+" : ""}${Math.round(
  //         irrigationLegendLabel[2]
  //       )}%</div><br/>`;
  //     div.innerHTML += `<div class ='legendContent'><i style="background-image:${"url(/images/blue_circle.png); background-size:contain;"
  //       }"></i>${irrigationLegendLabel[2] > 0 ? "+" : ""}${Math.round(
  //         irrigationLegendLabel[2] + 1
  //       )}% to ${irrigationLegendLabel[3] > 0 ? "+" : ""}${Math.round(
  //         irrigationLegendLabel[3]
  //       )}%</div><br/>`;
  //     div.innerHTML += `<div class ='legendContent'><i style="background-image:${"url(/images/blue_dots.png); background-size:contain;"
  //       }"></i>${irrigationLegendLabel[3] > 0 ? "+" : ""}${Math.round(
  //         irrigationLegendLabel[3] + 1
  //       )}% to ${irrigationLegendLabel[4] > 0 ? "+" : ""}${Math.round(
  //         irrigationLegendLabel[4]
  //       )}%</div><br/>`;
  //     div.innerHTML += `<div class ='legendContent'><i style="background-image:url(/images/black_stripe.png); background-size:contain;"></i>${irrigationLegendLabel[4] > 0 ? "No Change" : ""
  //       }</div><br/>`;

  //     return div;
  //   };
  // }
  //   else {
  //     irrigationLegendAllData.onAdd = function (map) {
  //       var div = L.DomUtil.create("div", "info irrigation-legend legend");
  //       div.setAttribute("style", "margin-right: 40px;width: 100px");
  //       div.innerHTML += `<div style="padding: 0px 0px 15px" class='legendTitle'> % Change <br> </div>`;
  //       div.innerHTML += `<div class ='legendContent'><i style="background-image:url(/images/black_stripe.png); background-size:contain;"></i>${"No Change"
  //         }</div><br/>`;
  
  //       return div;
  //     };
  //   }
  //   if (irrigationSelected) {
  //     irrigationLegendAllData.addTo(map);
  //   }
  // }, [irrigationSelected, powerSelected, miningSelected, toggle_about, access_difference_range]);


  //   renders the filter components in a div component
  useEffect(() => {
    if (widget) {
      const container = containerRef.current;
      ReactDOM.render(widget, container);
    }
  }, [widget]);

  useEffect(() => {
    const container = containerRef.current;
    return () => {
      ReactDOM.unmountComponentAtNode(container);
    };
  }, [containerRef]);

  useEffect(() => {
    if (widget1) {
      const container = containerRef1.current;
      ReactDOM.render(widget1, container);
    }
  }, [widget1]);

  useEffect(() => {
    const container = containerRef1.current;
    return () => {
      ReactDOM.unmountComponentAtNode(container);
    };
  }, [containerRef1]);

  const componentMountHook = () => {
    if (userLastSelectedMapState?.zoom) {
      // Restore the map state
      map.setView(
        userLastSelectedMapState.center,
        userLastSelectedMapState.zoom
      );
    }
    return () => {
      const mapState = {
        center: map.getCenter(),
        zoom: map.getZoom(),
      };
      setUserLastSelectedMapState(mapState);
    };
  };

  useEffect(componentMountHook, []);
  
  return (
    <Box className={classes.mapArea}>
      <div className={classes.map} id="map"></div>
    </Box>
  );
}

export default ColoradoRiverAccessMap;
